import { Pipe, PipeTransform } from '@angular/core';

import { IOrderTransferInterface } from '../interfaces/order-transfers.interface';

@Pipe({
  name: 'orderTransferSupplierPurchase',
})
export class OrderTransferPurchaseOrderReceivedPipe implements PipeTransform {
  transform(orderTransfers :IOrderTransferInterface, color :string) :string {
    if (
      !orderTransfers.supplierPurchaseOrder ||
      (orderTransfers.supplierPurchaseOrder &&
        !orderTransfers.supplierPurchaseOrder.receivingReportRfq)
    ) {
      return color;
    } else {
      return '#95969a';
    }
  }
}
